<header class="camben-header-light">

  <div class="camben-header-top-light">
    <div class="container d-flex align-items-center justify-content-between">
      
      <a class="camben-logo-light" routerLink="/">
        <img src="../../../assets/camben.png" alt="Camben" height="40">
      </a>

      <div class="camben-search-light">
        <div class="input-group search-input-group">
          <input type="text"
                 class="form-control camben-search-input-light"
                 placeholder="Busca en Camben..."
                 [(ngModel)]="searchTerm"
                 (keyup.enter)="search()">
          <span class="input-group-text search-icon">
            <button class="camben-search-button-light" (click)="search()">
              <i class="bi bi-search"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="camben-nav-right-light">
        
        <a class="camben-nav-link-light" [matMenuTriggerFor]="accountMenu">
          <span>
            Hola, identifícate
            <br>
            <strong>Cuenta</strong>
            <i class="bi bi-chevron-down"></i>
          </span>
        </a>
        <mat-menu #accountMenu="matMenu">
          <button mat-menu-item routerLink="/login">Identifícate</button>
          <div class="menu-item-row">
            <span>Si eres cliente nuevo</span>
            <a routerLink="/registro">Regístrate</a>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item routerLink="/cuenta">Mi Cuenta</button>
          <button mat-menu-item routerLink="/pedidos">Mis Pedidos</button>
          <button mat-menu-item routerLink="/cupones">Mis Cupones</button>
        </mat-menu>

        <a class="camben-cart-link-light" routerLink="/cart">
          <i class="bi bi-cart"></i>
          <span class="cart-count-light">{{cartProductCount}}</span>
        </a>
      </div>
    </div>
  </div>

  <div class="camben-header-bottom-light">
    <div class="container">
      <nav class="navbar navbar-expand-lg p-0">
        <button class="navbar-toggler" 
                type="button" 
                data-bs-toggle="collapse" 
                data-bs-target="#navbarNav" 
                aria-controls="navbarNav" 
                aria-expanded="false" 
                aria-label="Toggle navigation" 
                (click)="toggleMenu()">
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <div [ngClass]="{'collapse': !isMenuOpen, 'navbar-collapse': true}" id="navbarNav">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" 
                role="button" 
                (click)="toggleHomeMenu()" aria-expanded="false">
                Home
              </a>
              
              <ul class="dropdown-menu" 
                  [ngClass]="{'show': isHomeMenuOpen}" aria-labelledby="homeDropdown">
                
                <li>
                  <a class="dropdown-item" routerLink="/TiendaClubAdventista">Uniformes adventistas</a> 
                </li>

                <li>
                  <a class="dropdown-item" routerLink="/PlayerasPersonalizadas">Playeras</a> 
                </li>
                
                <!--li>
                  <a class="dropdown-item" routerLink="/CamisasPersonalizadas">Camisas</a> 
                </li-->
              </ul>
            </li>
            
            <li class="nav-item">
              <a class="nav-link" routerLink="/product">Tienda</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/login">Identificate/Registrate</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/pedidos">Pedidos</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/encuesta">Contáctanos</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/quienes-somos">Quiénes somos</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/preguntas-frecuentes">Preguntas frecuentes</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</header>